import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { OrderCard } from "../components/OrderCard";

export default function Account() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/my/orders").then(({ data }) => setOrders(data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-[1000px] mx-auto px-6 lg:px-8 py-10">
      <div className="flex items-center justify-between mb-8">
        <div>
          <p className="font-mono text-yellow-400 uppercase tracking-widest text-xs">My Account</p>
          <h1 className="font-heading font-black uppercase text-4xl text-white mt-1">{user?.name}</h1>
          <p className="text-zinc-500 mt-1 text-sm">{user?.email}</p>
        </div>
        <Link to="/shop" className="btn-primary px-6 py-3 rounded-sm">Shop Gear</Link>
      </div>

      <h2 className="font-heading font-bold uppercase text-2xl text-white mb-4">Order History</h2>
      {orders.length === 0 ? (
        <div className="text-zinc-500 font-mono py-16 text-center bg-[#121216] border border-white/10 rounded-lg">
          No orders yet. <Link to="/shop" className="text-yellow-400">Start shopping →</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => <OrderCard key={o.id} order={o} />)}
        </div>
      )}
    </div>
  );
}
